interface Props {
  title: string;
  phase: string;
}

export function Placeholder({ title, phase }: Props) {
  return (
    <div className="space-y-2">
      <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
      <p className="text-sm text-muted-foreground">
        Wired in {phase}. The route exists so the sidebar reflects the v1 structure from day one.
      </p>
    </div>
  );
}
